export enum ModalIconType {
  WARNING,
  LEAVE,
  SUCCESS,
}
